import requestAction from '../../utils/requestAction'

export const fetchTeachers = (params: string = "") =>
  requestAction('REMOTE_TEACHER_LIST', params)(`remote-teachers`, 'GET')

//This action requests all teachers without the calculated values
export const fetchAllTeachers = (params: string = "") =>
  requestAction('REMOTE_TEACHER_LIST', params)(`all-remote-teachers`, 'GET')

export const fetchTeachersOrderedBySuggestion = (teacherId: number, level: string, slotTime: number, dayOfWeek: number) => 
  fetchTeachers(`/suggestion?level=${level[0]}&slotTime=${slotTime}&dayOfWeek=${dayOfWeek}&teacherId=${teacherId}`)